module.exports = __webpack_public_path__ + "static/media/RGM_Hubble_logo-2.65016d61.mp4";